module.exports = __webpack_public_path__ + "static/img/rank-0.0edf1b90.png";